import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import {
  IPaginatedListOfComponentTemplateDto,
  PaginatedListOfComponentTemplateBriefDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";
import { useQueryClient } from "@tanstack/react-query";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";

//Use to delete component template from the component template library page
export const useDeleteComponentTemplateLibraryMutation = () => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template removed",
    queryKey: [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY],
    mutationFn: ComponentsService.removeComponentTemplate,
    optimisticUpdater: {
      updateFn: (oldData: IPaginatedListOfComponentTemplateDto, id) => {
        return {
          ...oldData,
          items: oldData.items.filter((item) => item.id !== id),
        };
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
    options: {
      onSuccess(_, variables) {
        queryClient.setQueryData(
          [COMPONENT_TEMPLATES_LIST_QUERY_KEY],
          (oldData: PaginatedListOfComponentTemplateBriefDto) => {
            if (!oldData) return oldData;
            return PaginatedListOfComponentTemplateBriefDto.fromJS({
              ...oldData,
              items: oldData.items.filter((item) => item.id !== variables),
            });
          },
        );
      },
    },
  });
};
